// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__U3PNs","header":"MessagesList_header__2piZ-","chat":"MessagesList_chat__dMB7H"};